import ButtonElement from './button'
import Icon from './icon'

import './style/css'

const Button = Object.assign(ButtonElement, { Icon })

export default Button
